<template>
  <div v-if="loading" class="min-h-screen grid grid-cols-1 gap-1 place-items-center">
    <Loading/>
  </div>
  <div v-else>
    <MenuList :menuMergedItems="$store.getters.menuMergedItems"/>
  </div>
</template>

<script>
import Loading from '@/components/ui/Loading'
import MenuList from '@/components/MenuList'

export default {
  props: ['toBasketFunc', 'payFunc'],

  data: () => ({
		loading: true,
	}),

  async mounted() {
    this.loading = true
    window.Telegram.WebApp.MainButton.onClick(this.toBasketFunc)
    window.Telegram.WebApp.MainButton.offClick(this.payFunc)
    this.changeTgBtn()
    try {
      await this.$store.dispatch('loadMenu')
    } finally {
      this.loading = false
    }
	},

	computed: {
    currentSlotsSelected() {
      let result = []
      this.$store.getters.currentSlots.forEach(elem => {
        result.push({ 
          text: `${elem.start_time.slice(0, -3)} - ${elem.end_time.slice(0, -3)}`,
          value: elem.id
        })
      })
      return result
    }
	},

	methods: {
		changeTgBtn() {
			const basketItems = Object.values(this.$store.getters.basket)
			if (basketItems.length > 0) {
				window.Telegram.WebApp.isClosingConfirmationEnabled = true
				window.Telegram.WebApp.MainButton.text = `Мой заказ ${basketItems.reduce(
					(accumulator, val) => accumulator + (val.quantity * val.item.price), 0
				)} ₽`
				window.Telegram.WebApp.MainButton.show()
			} else {
				window.Telegram.WebApp.isClosingConfirmationEnabled = false
				window.Telegram.WebApp.MainButton.hide()
			}
		},
    toBasket() {
      this.$router.push('/basket')
    }
	},

  components: { Loading, MenuList }
}
</script>

<style>

</style>